/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Accordion_TechnologiesInputs */

const en_us2_search_accordion_technologies = /** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologies`)
};

const es_es2_search_accordion_technologies = /** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologías`)
};

const ru_search_accordion_technologies = /** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технологии`)
};

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const id_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const ms_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const da_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const de_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const es_mx2_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const fil_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const fr_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const it_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const hu_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const nl_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const no_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const pl_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const pt_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const pt_br2_search_accordion_technologies = pt_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const ro_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const fi_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const sv_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const vi_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const tr_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const cs_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const bg_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const uk_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const ar_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const hi_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const th_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const ja_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const zh_cn2_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const zh_hant1_search_accordion_technologies = en_us2_search_accordion_technologies;

/** @type {(inputs: Search_Accordion_TechnologiesInputs) => LocalizedString} */
const ko_search_accordion_technologies = en_us2_search_accordion_technologies;

/**
* | output |
* | --- |
* | "Technologies" |
*
* @param {Search_Accordion_TechnologiesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_accordion_technologies = /** @type {((inputs?: Search_Accordion_TechnologiesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Accordion_TechnologiesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_accordion_technologies(inputs)
	if (locale === "ms") return ms_search_accordion_technologies(inputs)
	if (locale === "da") return da_search_accordion_technologies(inputs)
	if (locale === "de") return de_search_accordion_technologies(inputs)
	if (locale === "en-US") return en_us2_search_accordion_technologies(inputs)
	if (locale === "es-ES") return es_es2_search_accordion_technologies(inputs)
	if (locale === "es-MX") return es_mx2_search_accordion_technologies(inputs)
	if (locale === "fil") return fil_search_accordion_technologies(inputs)
	if (locale === "fr") return fr_search_accordion_technologies(inputs)
	if (locale === "it") return it_search_accordion_technologies(inputs)
	if (locale === "hu") return hu_search_accordion_technologies(inputs)
	if (locale === "nl") return nl_search_accordion_technologies(inputs)
	if (locale === "no") return no_search_accordion_technologies(inputs)
	if (locale === "pl") return pl_search_accordion_technologies(inputs)
	if (locale === "pt-BR") return pt_br2_search_accordion_technologies(inputs)
	if (locale === "pt") return pt_search_accordion_technologies(inputs)
	if (locale === "ro") return ro_search_accordion_technologies(inputs)
	if (locale === "fi") return fi_search_accordion_technologies(inputs)
	if (locale === "sv") return sv_search_accordion_technologies(inputs)
	if (locale === "vi") return vi_search_accordion_technologies(inputs)
	if (locale === "tr") return tr_search_accordion_technologies(inputs)
	if (locale === "cs") return cs_search_accordion_technologies(inputs)
	if (locale === "bg") return bg_search_accordion_technologies(inputs)
	if (locale === "ru") return ru_search_accordion_technologies(inputs)
	if (locale === "uk") return uk_search_accordion_technologies(inputs)
	if (locale === "ar") return ar_search_accordion_technologies(inputs)
	if (locale === "hi") return hi_search_accordion_technologies(inputs)
	if (locale === "th") return th_search_accordion_technologies(inputs)
	if (locale === "ja") return ja_search_accordion_technologies(inputs)
	if (locale === "zh-CN") return zh_cn2_search_accordion_technologies(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_accordion_technologies(inputs)
	return ko_search_accordion_technologies(inputs)
});
export { search_accordion_technologies as "search.accordion.technologies" }